var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.polygon)?_c('div',[_c('CanopyLayerSelect',{attrs:{"currentLayer":_vm.currentLayer}}),_c('SymbologyAttributeSelect')],1):_c('PolygonDetails',{attrs:{"polygon":_vm.polygon,"currentLayer":_vm.currentLayer}}),_c('v-divider',{staticClass:"my-2"}),_c('Histogram',{attrs:{"currentLayer":_vm.currentLayer,"polygon":_vm.polygon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }